module.exports = __webpack_public_path__ + "static/media/DSC_0260.7432cf0b.jpg";